import './assign';
import { BUNDLES, createScriptLoader, firstChunk, preLoad, secondChunk } from './loaderUtils';

[...firstChunk, ...secondChunk].map(preLoad);

export const loadUtils = createScriptLoader(BUNDLES.UTILS);
export const loadApp = createScriptLoader(BUNDLES.APP);
export const loadConsoleLogger = createScriptLoader(BUNDLES.LOGGER);
